import React, {createContext, useEffect, useState} from 'react';
import LobbyModalContainer from "../common/lobby_modal_container";
import swal from "sweetalert";

interface LobbyInterface {
    SetLobbyShow: () => void
    SetVendor: (thisVendor: string) => void
    SetType: (thisType: gameType) => void
}
export type gameType = "casino" | "slot"

export const lobbyModalContext = createContext<LobbyInterface>({
    SetLobbyShow: () => {},
    SetVendor: (thisVendor: string) => {},
    SetType: (thisType: gameType) => {}
})
function LobbyModalProvider({children}: {children: React.ReactNode}) {
    const [lobbyShow, setLobbyShow] = useState<boolean>(false)
    const [vendor, setVendor] = useState<string>("")
    const [type, setType] = useState<gameType>("slot")
    function SetLobbyShow(){
        setLobbyShow(true)
    }
    function SetVendor(thisVendor: string){
        setVendor(thisVendor)
    }
    function SetType(thisType: gameType){
        setType(thisType)
    }
    return (
        <lobbyModalContext.Provider value={{SetLobbyShow, SetVendor, SetType}}>
            {children}
            <LobbyModalContainer show={lobbyShow} setShow={setLobbyShow} vendor={vendor} type={type}/>
        </lobbyModalContext.Provider>
    );
}

export default LobbyModalProvider;